import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@boveda/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: ({ params }) => {
    // Per-tab gating: resolve THIS tab's active account (URL `/u/<n>` →
    // registry), NOT the global session machine. The global machine holds only
    // the last-authed real user, so gating on it would let a GUEST tab into
    // /admin whenever any real admin is signed in elsewhere. The `u` param IS
    // this tab's active-account index.
    const index = (params as { u?: number }).u ?? null;
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      index,
      sessionActor.getSnapshot().context.session,
    );

    // Back-office (#18): allow any admin-capable role (super_admin/admin/support/
    // read_only). The backend re-checks every action by capability; the per-page
    // UI hides/disables actions a role can't perform. A plain `user` / guest is
    // bounced.
    if (!isAdminCapable(view.role)) {
      // Stay within THIS tab's account prefix (`/u/<n>/profile`).
      // oxlint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/u/$u/profile", params: { u: (params as { u: number }).u } });
    }
  },
  component: () => <Outlet />,
});
